import { TrackerCard } from '@/components/tracker/TrackerCard';
import type { KanbanColumnDef } from '@/components/tracker/tracker.types';
import { ScrollPane } from '@/components/ui/ScrollPane';
import type { Job } from '@/types/job.type';

interface KanbanColumnProps {
  column: KanbanColumnDef;
  jobs: Job[];
  onSelect: (id: number) => void;
}

export const KanbanColumn = ({ column, jobs, onSelect }: KanbanColumnProps) => (
  <div className="flex w-full shrink-0 flex-col rounded-lg border border-border bg-surface/40">
    <div className="flex items-center justify-between border-b border-border px-3 py-2">
      <div>
        <p className="text-xs lg:text-sm font-medium">{column.label}</p>
        <p className="font-mono text-xs tracking-wide text-subtle uppercase">
          {column.hint}
        </p>
      </div>
      <span className="font-mono text-xs lg:text-sm text-foreground-muted tabular-nums">
        {jobs.length}
      </span>
    </div>
    <ScrollPane className="min-h-0 flex-1" viewportClassName="space-y-1.5 p-2">
      {jobs.length === 0 ? (
        <div className="flex h-full min-h-40 items-center justify-center px-3 text-center">
          <p className="font-mono text-2xs lg:text-xs text-subtle">— empty —</p>
        </div>
      ) : (
        jobs.map((job) => (
          <TrackerCard
            job={job}
            key={job.id}
            onClick={() => onSelect(job.id)}
          />
        ))
      )}
    </ScrollPane>
  </div>
);
